import jwt from 'jsonwebtoken';
import createQueryString from '../utils/queryString';
import http from './http';

const URL_ROOT = '/utenti';
const URL_ROOT_OPERATOR = `${URL_ROOT}/operatore`;
const URL_ROOT_AGENCY = `${URL_ROOT}/agenzia`;

export const activateUser = async (id) => {
  const response = await http.patch(`${URL_ROOT}/${id}/enable`, null, {notify: 'Utente abilitato'});
  return response.data;
};

export const deactivateUser = async (id) => {
  const response = await http.patch(`${URL_ROOT}/${id}/disable`, null, {notify: 'Utente disabilitato'});
  return response.data;
};

export const updatePassword = async (id, password) => {
  const response = await http.patch(`${URL_ROOT}/${id}/password`, { password }, {notify: 'La password dell\'utente è stata modificata'});
  return response.data;
};

export const impersonate = async (id) => {
  try {
    // TODO put the current token in localstorage, when exiting impersonate mode replace the current token with this one
    // const user = JSON.parse(localStorage.getItem('user'));
    // const oldToken = user;
    // localStorage.setItem('oldToken', JSON.stringify(oldToken));
    const response = await http.get(`${URL_ROOT}/${id}/token`);
    const newToken = jwt.decode(response.data.token);

    localStorage.setItem('user', JSON.stringify({ ...newToken, token: response.data.token }));

    window.location.href = '/';
  } catch (error) {
    console.log(error);
  }
};

export const impersonateAgency = async (id) => {
  try {
    // TODO put the current token in localstorage, when exiting impersonate mode replace the current token with this one
    // const user = JSON.parse(localStorage.getItem('user'));
    // const oldToken = user;
    // localStorage.setItem('oldToken', JSON.stringify(oldToken));
    const response = await http.get(`${URL_ROOT}/${id}/token`);
    const newToken = jwt.decode(response.data.token);

    localStorage.setItem('user', JSON.stringify({ ...newToken, token: response.data.token }));

    window.location.href = '/agenzia';
  } catch (error) {
    console.log(error);
  }
};

//  OPERATORS
//= ============

export const getUsers = async (filters) => {
  let url = URL_ROOT_OPERATOR;

  if (filters) {
    url += createQueryString(filters);
  }

  const response = await http.get(url);
  return response.data;
};

export const getUser = async (id) => {
  const response = await http.get(`${URL_ROOT_OPERATOR}/${id}`);
  return response.data;
};

export const createUser = async (data) => {
  const response = await http.post(`${URL_ROOT_OPERATOR}`, data);
  return response.data;
};

export const updateUser = async (id, data) => {
  const response = await http.put(`${URL_ROOT_OPERATOR}/${id}`, data);
  return response.data;
};

export const getSocial = async (id) => {
  const response = await http.get(`${URL_ROOT_OPERATOR}/${id}/social`);
  return response.data;
};

export const updateSocial = async (id, data) => {
  const response = await http.post(`${URL_ROOT_OPERATOR}/${id}/social`, data);
  return response.data;
};

//  AGENCIES
//= ============

export const getAgencies = async (filters) => {
  let url = URL_ROOT_AGENCY;

  if (filters) {
    url += createQueryString(filters);
  }

  const response = await http.get(url);
  return response.data;
};

export const getAgency = async (id) => {
  const response = await http.get(`${URL_ROOT_AGENCY}/${id}`);
  return response.data;
};

export const createAgency = async (data) => {
  const response = await http.post(`${URL_ROOT_AGENCY}`, data);
  return response.data;
};

export const updateAgency = async (id, data) => {
  const response = await http.put(`${URL_ROOT_AGENCY}/${id}`, data);
  return response.data;
};
